export interface TextFieldProps {
  type: "text" | "password" | "number" | "search" | "tel";
  value: any;
  propertyId: string;
  name: string;
  disabled?: boolean;
  isValid?: () => boolean;
  mandatory?: boolean;
  placeholder?: string;
  label: string;
  hiddenLabel?: boolean;
  floatingLabel?: boolean;
  legend?: string;
  maxLength?: number;
  min?: number;
  max?: number;
  step?: number;
  reset?: boolean;
  inputChangeHandler?: () => void;
  additionalProps?: string;
  inputTitle: string;
}

export enum InputType {
  TEXT = "text",
  PASSWORD = "password",
  NUMBER = "number",
  SEARCH = "search",
  TEL = "tel",
}
